import React from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography, Paper } from '@mui/material';
import { SafetyPrecautionsChecklist } from '../types';

interface SafetyPrecautionsListProps {
    safetyPrecautionsChecklist: SafetyPrecautionsChecklist;
    isViewMode: boolean;
    onSafetyPrecautionsChange: (itemKey: string, value: boolean | string) => void;
}

export const SafetyPrecautionsList: React.FC<SafetyPrecautionsListProps> = ({
    safetyPrecautionsChecklist,
    isViewMode,
    onSafetyPrecautionsChange
}) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6" sx={{ background: '#f4a460', p: 1, borderRadius: 1, mb: 2 }}>
                進入密閉空間內工作必須採取以下所有的安全預防措施
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, fontStyle: 'italic' }}>
                除基於危險評估的預防措施外,擁有人或承建商必須採取以下措施,才可讓核准工人進入密閉空間內工作:
            </Typography>

            <Box>
                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item1}
                                onChange={e => onSafetyPrecautionsChange('item1', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="1. 確保密閉空間內所有具危險性的機械設備的電源已被切斷,並在電源開關上掛上警告標籤及上鎖;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item2}
                                onChange={e => onSafetyPrecautionsChange('item2', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="2. 確保密閉空間內所有載有具危害性物質的喉管或供應線已妥當地密封;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item3}
                                onChange={e => onSafetyPrecautionsChange('item3', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="3. 對密閉空間內的空氣進行測試,以確定沒有具危害性的氣體及沒有貧氧情況;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item4}
                                onChange={e => onSafetyPrecautionsChange('item4', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="4. 在考慮密閉空間的情況後,已充分地清潔、充分地通風,並已確定為安全的工作場所;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item5}
                                onChange={e => onSafetyPrecautionsChange('item5', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="5. 確保密閉空間內有足夠的可呼吸空氣及有效的強制通風;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item6}
                                onChange={e => onSafetyPrecautionsChange('item6', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="6. 採取有效的步驟以防止(i)具危害性的氣體、蒸氣、塵埃或煙氣進入;及(ii)自由流動的固體或液體進入密閉空間;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item7.main}
                                onChange={e => onSafetyPrecautionsChange('item7.main', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="7. 在進入前,使用適當的防爆空氣監測設備測試:"
                    />
                    <Box sx={{ ml: 4, mt: 1 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={safetyPrecautionsChecklist.item7.oxygen}
                                    onChange={e => onSafetyPrecautionsChange('item7.oxygen', e.target.checked)}
                                    disabled={isViewMode}
                                />
                            }
                            label="氧氣"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={safetyPrecautionsChecklist.item7.explosiveLimit}
                                    onChange={e => onSafetyPrecautionsChange('item7.explosiveLimit', e.target.checked)}
                                    disabled={isViewMode}
                                />
                            }
                            label="爆炸下限"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={safetyPrecautionsChecklist.item7.hydrogenSulfide}
                                    onChange={e => onSafetyPrecautionsChange('item7.hydrogenSulfide', e.target.checked)}
                                    disabled={isViewMode}
                                />
                            }
                            label="硫化氫"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={safetyPrecautionsChecklist.item7.carbonMonoxide}
                                    onChange={e => onSafetyPrecautionsChange('item7.carbonMonoxide', e.target.checked)}
                                    disabled={isViewMode}
                                />
                            }
                            label="一氧化碳"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={safetyPrecautionsChecklist.item7.other}
                                    onChange={e => onSafetyPrecautionsChange('item7.other', e.target.checked)}
                                    disabled={isViewMode}
                                />
                            }
                            label="其他:"
                        />
                        <TextField
                            size="small"
                            disabled={isViewMode}
                            sx={{ width: 200, ml: 2 }}
                            placeholder="請輸入其他項目"
                            value={safetyPrecautionsChecklist.item7.otherText}
                            onChange={e => onSafetyPrecautionsChange('item7.otherText', e.target.value)}
                        />
                    </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item8}
                                onChange={e => onSafetyPrecautionsChange('item8', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="8. 並進行連續性的空氣監測,直到所有人離開該密閉空間為止;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item9}
                                onChange={e => onSafetyPrecautionsChange('item9', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="9. 訂立緊急程序及提供足夠和令人滿意的設備,並在密閉空間外隨時可供使用,包括:
                        (a) 認可呼吸器具;
                         (b) 使失去知覺的工人復甦的適當器具;
                         (c) 儲存氧氣或空氣的器具;
                        (d) 安全吊帶及繩索;
                         (e) 使密閉空間內的工人能向身在密閉空間外的人示警的聽覺與視覺警報器;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item10}
                                onChange={e => onSafetyPrecautionsChange('item10', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="10. 確保有足夠數目的受訓人員組成緊急救援隊伍,並準備實施緊急程序,該等人員須接受救援計劃及設備操作的訓練;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item11}
                                onChange={e => onSafetyPrecautionsChange('item11', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="11. 向所有工人(包括在密閉空間內及外的工人)提供指引、訓練及意見,以確保安全及健康,並在入口處張貼清晰的警告標籤,說明危險及須採取的預防措施;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item12}
                                onChange={e => onSafetyPrecautionsChange('item12', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="12. 提供所有為工人安全及健康所需的設備,包括在有需要時進行連續監測的適當防爆空氣監測設備;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item13}
                                onChange={e => onSafetyPrecautionsChange('item13', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="13. 確保只有獲核准的人員才可進入或在密閉空間內工作;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item14}
                                onChange={e => onSafetyPrecautionsChange('item14', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="14. 確保至少有1名「候命人」在密閉空間外,與密閉空間內的工人保持聯絡;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item15}
                                onChange={e => onSafetyPrecautionsChange('item15', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="15. 在入口處的顯眼地方展示危險評估報告及工作許可證;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item16}
                                onChange={e => onSafetyPrecautionsChange('item16', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="16. 確保所列的安全預防措施在工人逗留在密閉空間內期間保持有效;"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={safetyPrecautionsChecklist.item17.main}
                                onChange={e => onSafetyPrecautionsChange('item17.main', e.target.checked)}
                                disabled={isViewMode}
                            />
                        }
                        label="17. 其他安全預防措施:"
                    />
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        disabled={isViewMode}
                        placeholder="請輸入其他安全預防措施..."
                        size="small"
                        sx={{ mt: 1 }}
                        value={safetyPrecautionsChecklist.item17.other}
                        onChange={e => onSafetyPrecautionsChange('item17.other', e.target.value)}
                    />
                </Box>
            </Box>
        </Paper>
    );
};